import React from "react";
// import buildingImg from "../assets/about.jpg";
import buildingImg from "../assets/PortatraitOwner 1.png";
import buildingImg1 from "../assets/TIG Website Images/Home/About TIG.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect,useState } from "react";

const HomeAbout = () => {
    useEffect(() => {
  AOS.init({ duration: 1000 });
}, []);

const Counter = ({ target, duration, suffix }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = target / (duration / 20); // update every 20ms
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(timer);
        setCount(target);
      } else {
        setCount(Math.floor(start));
      }
    }, 20);

    return () => clearInterval(timer);
  }, [target, duration]);

  return <h3 className="mb-0">{count}{suffix}</h3>;
};
  return (
    // <section className="container-fluid px-0 " data-aos="fade-up">
    //   <div className="row g-0 align-items-stretch" style={{ minHeight: "70vh", backgroundColor: "#EAF9FF" }}>
      
    //     <div className="col-lg-4 d-none d-lg-block">
    //       <div className="h-100">
    //         <img
    //           src={buildingImg}
    //           alt="Building"
    //           className="w-100 h-100"
    //           style={{ objectFit: "cover" }}
    //         />
    //       </div>
    //     </div>
    //     <div className="col-lg-8  d-flex flex-column justify-content-between px-4 pt-3 px-md-5">
    //       <div>
    //         <h4 className="fw-bold mb-2">About Towers International Group (TIG)</h4>
    //         <h5 className=" fw-semibold mb-4" style={{color: "#2A2A2A" }}>
    //           Your Trusted Partner in Payroll, Recruitment, Branding, IT & Construction
    //         </h5>
    //          <div className="row about-para">
    //           <div className="col-md-6">
    //             <p className="mb-2">
    //               Established in 1999, Towers International Group (TIG) is a distinguished Omani-owned Small and Medium Enterprise (SME) with over two decades of trusted service delivery  sectors in Oman and the wider region. Headquartered in Muscat,
    //             </p>
    //             <p className="mb-0">
    //               TIG was founded by Mr. Ahmed Qadir Al Balushi a former banking executive with more than 30 years of leadership experience and has since grown into a dynamic, multi-faceted  conglomerate that aligns its operations with Oman’s national vision for economic diversification, youth empowerment, and SME development under the guidance of His Majesty Sultan Haitham bin Tariq.</p>
    //           </div>
    //            <div className="col-md-6">
    //             <div>
    //               <h5 className="fw-bold">Our Mission</h5>
    //               <p>
    //                 To deliver reliable, high-quality outsourced professionals with global expertise
    //                 in banking, IT solutions, and product marketing—building strong, sustainable
    //                 service capabilities for our clients.
    //               </p>
    //             </div>
    //             <div>
    //               <h5 className="fw-bold">Our Vision</h5>
    //               <p>
    //                 To be recognized as a trusted provider of skilled, success-driven professionals—
    //                 delivering top-tier talent with strong ethics and global-level competence, both
    //                 locally and abroad.
    //               </p>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="row text-white text-center bottom-state">
    //         <div className="col-md-4 py-4" style={{backgroundColor:"#061E42"}}>
    //           <h3 className="mb-0">50+</h3>
    //           <p className="mb-0">Happy Clients</p>
    //         </div>
    //         <div className="col-md-4 py-4" style={{backgroundColor:"#2A2A2A"}}>
    //           <h3 className="mb-0">500+</h3>
    //           <p className="mb-0">Project Done</p>
    //         </div>
    //          <div className="col-md-4 py-4" style={{backgroundColor:"#061E42"}}>
    //           <h3 className="mb-0">24+</h3>
    //           <p className="mb-0">Years of Experience</p>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
     <section className="container-fluid px-0 " data-aos="fade-up">
      <div className="row g-0 align-items-stretch" style={{ minHeight: "70vh", backgroundColor: "#EAF9FF" }}>
       <div className="col-lg-8  d-flex flex-column justify-content-between px-4 pt-3 px-md-5">
          <div>
            <h4 className="fw-bold mb-2">About Towers International Group (TIG)</h4>
            <h5 className=" fw-semibold mb-4" style={{color: "#2A2A2A" }}>
              Your Trusted Partner in Payroll, Recruitment, Branding, IT & Construction
            </h5>
             <div className="row about-para">
              <div className="col-md-6">
                <p className="mb-2">
                  Established in 1999, Towers International Group (TIG) is a distinguished Omani-owned Small and Medium Enterprise (SME) with over two decades of trusted service delivery  sectors in Oman and the wider region. Headquartered in Muscat,
                </p>
                 <div className="row text-dark ">
      <div className="col-md-6 py-3" >
        <Counter target={50} duration={1500} suffix="+" />
        <p className="mb-0">Happy Clients</p>
      </div>
      <div className="col-md-6 py-3">
        <Counter target={500} duration={2000} suffix="+" />
        <p className="mb-0">Project Done</p>
      </div>
      <div className="col-md-6 py-2" >
        <Counter target={24} duration={1200} suffix="+" />
        <p className="mb-0">Years of Experience</p>
      </div>
    </div>
                {/* <p className="mb-0">
                  TIG was founded by Mr. Ahmed Qadir Al Balushi a former banking executive with more than 30 years of leadership experience and has since grown into a dynamic, multi-faceted  conglomerate that aligns its operations with Oman’s national vision for economic diversification, youth empowerment, and SME development under the guidance of His Majesty Sultan Haitham bin Tariq.</p> */}
              </div>
               <div className="col-md-6">
                <div>
                  <h5 className="fw-bold">Our Mission</h5>
                  <p>
                    To deliver reliable, high-quality outsourced professionals with global expertise
                    in banking, IT solutions, and product marketing—building strong, sustainable
                    service capabilities for our clients.
                  </p>
                </div>
                <div>
                  <h5 className="fw-bold">Our Vision</h5>
                  <p>
                    To be recognized as a trusted provider of skilled, success-driven professionals—
                    delivering top-tier talent with strong ethics and global-level competence, both
                    locally and abroad.
                  </p>
                </div>
              </div>
            </div>
          </div>
       
        </div>
        <div className="col-lg-4 d-none d-lg-block">
          <div className="h-100">
             <img
              src={buildingImg1}
              alt="Building"
              className="w-100 h-100"
              style={{ objectFit: "cover", height:'472px' }}
            />
          </div>
         </div>
      </div>
         <section className="py-3">
      <div className="container-fluid px-md-5">
        <div className="row align-items-center">
          {/* Left Text Section */}
          <div className="col-lg-9 col-md-7 mb-4 mb-md-0">
            <h2 className="fw-bold mb-3">Owner and Founder</h2>
            <p className="text-muted fs-5">
              TIG was founded by Mr. Ahmed Qadir Al Balushi a former banking executive with more than 30 years of leadership experience and has since grown into a dynamic, multi-faceted  conglomerate that aligns its operations with Oman’s national vision for economic diversification, youth empowerment, and SME development under the guidance of His Majesty Sultan Haitham bin Tariq.</p>
          
          </div>

          {/* Right Image Section */}
           <div className="col-lg-3 col-md-5 text-center">
            <div className="card border-0 bg-transparent">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  width: "100%",
                  height: "350px", // adjust height if needed
                  backgroundColor: "#fff",
                }}
              >
                <img
                  src={buildingImg}
                  alt="Owner"
                  className="img-fluid rounded"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain", // show full image
                    borderRadius: "12px",
                  }}
                />
              </div>

              <div className="card-body p-0 mt-3">
                <h5 className="fw-semibold mb-1">Ahmed Qadir Al Balushi</h5>
              
                  <i className="bi bi-linkedin"></i>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </section>
  );
};

export default HomeAbout;
